import { render } from "./SettingsDispenserColors.vue?vue&type=template&id=0298f96e"
import script from "./SettingsDispenserColors.vue?vue&type=script&lang=js"
export * from "./SettingsDispenserColors.vue?vue&type=script&lang=js"

import "./SettingsDispenserColors.vue?vue&type=style&index=0&id=0298f96e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__